import React, { Component } from 'react'
import './styles.css'
import {
  defineMessages,
  FormattedMessage
} from 'react-intl'
import Modal from 'components/Modal'
import Button from 'components/Button'
import { API_VERSION } from 'constants/api'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {isVisManager} from 'utils/visManager'

const messages = defineMessages({
  title: 'Camera/Microphone error.',
  retry: 'Retry',
  back: 'Back to Scheduling',
  body: 'Camera/Microphone access unavailable, please click the "Lock" icon in the top left corner next to the URL and make sure both are set to allow'
})

class CameraNotAccessibleModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      retryRequested: false
    }
    this.onTabClose = this.onTabClose.bind(this)
  }

  componentDidMount() {
    window.addEventListener('unload', this.onTabClose)
  }

  componentWillUnmount() {
    window.removeEventListener('unload', this.onTabClose)
  }

  onTabClose() {
    const {
      appointmentId,
      jwt
    } = this.props
    const client = isVisManager() ? 'vis_manager' : 'visit_now'

    if (!isVisManager() && appointmentId && jwt && !this.state.retryRequested) {
      navigator.sendBeacon(`${process.env.GVS_URL}/api/client/${API_VERSION}/${client}/visits/failed?jwt=${jwt}&visit[appointment_id]=${appointmentId}`)
    }
  }

  render() {
    const {
      show,
      onClose,
      redirectURL
    } = this.props

    return (
      <Modal
        title={(<FormattedMessage {...messages.title} />)}
        show={show}
        footer={(
          <Container>
            <Row>
              <Col>
                <Button
                  type='cancel'
                  onClick={() => {
                    if (redirectURL) {
                      window.location.replace(redirectURL)
                    }
                  }}
                >
                  <FormattedMessage {...messages.back} />
                </Button>
              </Col>
              <Col>
                <Button
                  type='ok'
                  onClick={() => {
                    this.setState({ retryRequested: true}, onClose)
                  }}
                >
                  <FormattedMessage {...messages.retry} />
                </Button>
              </Col>
            </Row>
          </Container>

        )}
      >
        <div data-testid='body' styleName='body'>
          <FormattedMessage {...messages.body} />
        </div>
      </Modal>
    )
  }

}

export default CameraNotAccessibleModal
